import { render } from "./WarehouseItem.vue?vue&type=template&id=5123894c"
import script from "./WarehouseItem.vue?vue&type=script&lang=js"
export * from "./WarehouseItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__